/**
 * 普通配置协议与升级协议共用的 byte0 位布局。
 * bit0-4: command；bit5-6: deviceType；bit7: 协议自定义标志。
 */
export const DeviceType = Object.freeze({
  USB: 0,
  MCU2: 1,
  WIRELESS: 2,
});

export function buildCommandByte(command, deviceType = DeviceType.USB, bit7 = 0) {
  const cmd = Number(command);
  const target = Number(deviceType);
  const highBit = Number(bit7);
  if (!Number.isInteger(cmd) || cmd < 0 || cmd > 0x1f) {
    throw new RangeError('command 必须是 0-31 的整数');
  }
  if (!Number.isInteger(target) || target < 0 || target > 0x03) {
    throw new RangeError('deviceType 必须是 0-3 的整数');
  }
  if (highBit !== 0 && highBit !== 1) {
    throw new RangeError('bit7 必须是 0 或 1');
  }
  return cmd | (target << 5) | (highBit << 7);
}

export function parseCommandByte(byte0) {
  const value = Number(byte0) & 0xff;
  return {
    raw: value,
    command: value & 0x1f,
    deviceType: (value >> 5) & 0x03,
    bit7: (value >> 7) & 0x01,
  };
}

export function matchesProtocolResponse(data, expected = {}) {
  if (!data || data.length === 0) return false;
  const header = parseCommandByte(data[0]);
  if (
    expected.command != null &&
    header.command !== Number(expected.command)
  ) {
    return false;
  }
  if (
    expected.deviceType != null &&
    header.deviceType !== Number(expected.deviceType)
  ) {
    return false;
  }
  if (expected.type != null && data[3] !== Number(expected.type)) {
    return false;
  }
  return true;
}
